module.exports = BD.Model.extend({
    match: BD.belongsTo('Billy.BankLineMatch'),
    account: BD.belongsTo('Billy.Account'),
    entryDate: BD.attr('date'),
    description: BD.attr('string'),
    amount: BD.attr('number'),
    side: BD.attr('side'),
    contraAccount: BD.belongsTo('Billy.Account'),
    provider: BD.attr('string')
})
